/**
 * @desc 为html页面增加一个视频，解决长时间不操作而导致电脑进入黑屏的问题
 * @argument 使用方式
 *      const sleep = new Sleep([src, type]);
 *              // 使用时机 模块内部的全局变量即可
 *              // [ src: 可选视频地址，不传的话，默认为"https://assets.souche.com/assets/sccimg//movie.mp4"
 *              //   type: 可选视频类型， 不传的话，默认为"video/mp4" ]
 *      sleep.wake();
 *              // 使用时机 componentDidMount
 *      sleep.noNeedWake();
 *              // 使用时机 componnetWillUnMount
 */
class Sleep {
    constructor(src = 'https://assets.souche.com/assets/sccimg//movie.mp4', type = 'video/mp4') {
        this.src = src;
        this.type = type;
    }
    create() {
        const hasVideoEl = document.getElementById('noSleepVideo');
        if (!hasVideoEl) {
            const _el = document.createElement('div');
            const _innerHTML = `
        <video id="noSleepVideo" loop autoplay muted="true">
            <source src="${this.src}" type='${this.type}'>
        </video>`;
            _el.innerHTML = _innerHTML;
            _el.style.display = 'none';
            document.body.appendChild(_el);
        }
    }
    wake() {
        this.create();
        const _v = document.getElementById('noSleepVideo');
        _v ? _v.setAttribute('loop', 'true') : '';
        // @ts-ignore
        _v ? _v.play ? _v.play() : '' : '';
    }
    noNeedWake() {
        const _v = document.getElementById('noSleepVideo');
        _v ? _v.setAttribute('loop', '') : '';
        // @ts-ignore
        _v ? _v.pause ? _v.pause() : '' : '';
    }
}
export default Sleep;
